export async function lookupReservationFlight(client, accountId, fields, signal) {
    const { data, error } = await client.auth.getSession();
    if (error || !data?.session) throw new Error('Sign in again to look up a flight.');
    const response = await fetch('/api/client/reservation-flight', {
        method: 'POST', signal, headers: { Authorization: `Bearer ${data.session.access_token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountId, number: fields.flightNumber, date: fields.date, airportCode: fields.airportCode, direction: fields.direction }),
    });
    const result = await response.json();
    if (!response.ok || !result.scheduledTime) throw new Error(result.error || 'Flight lookup is unavailable.');
    return result;
}
